module.exports = __webpack_public_path__ + "assets/img/w-c-3.66f3b909.png";